import React, { useState, useEffect } from 'react'
import axios from 'axios';
import './Activities.css';
import calendar from '../Photoset/calendar-days.png';
import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";

function Activities() {
    const [staffMembers, setStaffMembers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [staffsPerPage] = useState(8);

    useEffect(() => {
        // Fetch staff data for the "social" subject
        axios.get('https://school-web-server-eight.vercel.app/activities')
            .then(response => {
                setStaffMembers(response.data);
            })
            .catch(error => {
                console.error('Failed to fetch staff members:', error);
            });
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    
  // Pagination logic
  const indexOfLastStaff = currentPage * staffsPerPage;
  const indexOfFirstStaff = indexOfLastStaff - staffsPerPage;
  const currentStaffs = staffMembers.slice(indexOfFirstStaff, indexOfLastStaff);

  // Logic for displaying page numbers
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(staffMembers.length / staffsPerPage); i++) {
    pageNumbers.push(i);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // function handleClick() {
  //   console.log("Link clicked!");
  // }

    return (
        <>
            <div>
                <div className='subject-container'>
                    <div className='ac-container'>
                        <div className='header-ac-1'><div className='header'> 
                        <h1>ข่าวกิจกรรม</h1>
                        <p></p>
                    </div></div>
                    
                    <div className='staff'>
                        {currentStaffs.map((staff) => (
                            <div key={staff._id} className='staff-member-ac'>
                                <a href='{staff.link}'><img
                                    src={`https://school-web-server-eight.vercel.app/activities/${staff.image}`}
                                    alt=""
                                    style={{ width: '90%', height: '70%', objectFit: 'cover' }}
                                /></a>
                                <div className='personal-details'>
                                    <strong>{staff.name}</strong>
                                    <br />
                                    <div className='text-details'>
                                        {formatDate(staff.date)}
                                        <img
                                    src={calendar}
                                    alt="calender"
                                    style={{width: '16px', height: '16px'}}
                                /> 
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>{/* Pagination */}
          <ul className="pagination-ac">
            {/* Previous Page Button */}
            <li className="page-item">
              <button
                onClick={() => setCurrentPage(currentPage - 1)} // Go to Previous Page
                className="page-link"
                disabled={currentPage === 1}
              >
                <GoChevronLeft />
                ก่อนหน้า
              </button>
            </li>
            {/* Page Numbers */}
            {pageNumbers.map((number) => (
              <li key={number} className="page-item">
                <button
                  onClick={() => paginate(number)}
                  className={`page-link ${
                    currentPage === number ? "active" : ""
                  }`} // Highlight current page
                >
                  {number}
                </button>
              </li>
            ))}
            {/* Next Page Button */}
            <li className="page-item">
              <button
                onClick={() => setCurrentPage(currentPage + 1)} // Go to Next Page
                className="page-link"
                disabled={currentPage === pageNumbers.length}
              >
                ถัดไป <GoChevronRight />
              </button>
            </li>
          </ul>
                    </div>
                    
                </div>
            </div>
        </>
    )
}

export default Activities